import BrandLogo from "@/components/BrandLogo";

const supportItems = [
  {
    title: "Account Access",
    body: "The Seiko Event Portal is invitation-only. If you cannot sign in, ask your event manager or Seiko administrator to confirm that your account has been created and approved.",
  },
  {
    title: "Events And Availability",
    body: "For questions about assignments, applications, availability, schedules, travel details or event documents, contact the event manager listed in your event information.",
  },
  {
    title: "Documents And Training",
    body: "If you cannot upload or view required documents, or your training record looks incorrect, contact Seiko support with your name, email address and the event or training item affected.",
  },
  {
    title: "Technical Support",
    body: "Include your device model, iOS version, the screen you were using and a short description of what happened. Screenshots are helpful where they do not include sensitive information.",
  },
];

export default function Support() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-4xl flex-col gap-6 px-6 py-10">
          <div className="w-64 rounded-lg bg-black p-4">
            <BrandLogo alt="Seiko Sports Technologies" className="h-auto w-full" />
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">Seiko Event Portal</p>
            <h1 className="mt-2 text-4xl font-bold tracking-tight">Support</h1>
            <p className="mt-4 max-w-2xl text-base leading-7 text-slate-600">
              Help for authorised Seiko Event Portal users, event staff, contractors and managers.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 py-10">
        <div className="grid gap-5 sm:grid-cols-2">
          {supportItems.map((item) => (
            <section key={item.title} className="rounded-lg border border-slate-200 bg-white p-6">
              <h2 className="text-lg font-semibold">{item.title}</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">{item.body}</p>
            </section>
          ))}
        </div>

        <section className="mt-8 rounded-lg border border-slate-200 bg-white p-6">
          <h2 className="text-xl font-semibold">Contact Support</h2>
          <p className="mt-4 text-sm leading-6 text-slate-600">
            Email{" "}
            <a className="font-medium text-slate-900 underline" href="mailto:shaun.barratt@seikosportstech.co.uk">
              shaun.barratt@seikosportstech.co.uk
            </a>{" "}
            for account, access or technical support.
          </p>
        </section>
      </section>
    </main>
  );
}
